/**
 * Factory function pour créer des services CRUD standardisés.
 *
 * Phase 3 — Services API — Pattern Factory
 *
 * ⚠️  Les signatures conservent les noms et l'ordre de paramètres des
 *     anciens services pour une rétrocompatibilité à 100% :
 *       save(data)         — et non create(data)
 *       view(id)           — et non get(id)
 *       update(data, id)   — data en 1er, id en 2e (convention existante)
 *
 * Utilisation :
 *   import { createService } from '@/services/createService'
 *   export const groupesService = createService('/groupes')
 *   // → groupesService.list(), .save(data), .view(id), .update(data, id), .remove(id)
 *
 * Pour étendre un service CRUD avec des méthodes custom :
 *   export const clientsService = createService('/clients', {
 *     search (item, ifGetContrat) { return api.get(`/clients/search/${item}?ifGetContrat=${ifGetContrat}`) },
 *   })
 */
import api from './apiClient'

/**
 * Crée un service CRUD standard pour un endpoint donné.
 *
 * @param {string} endpoint — Le chemin de base (ex: '/clients')
 * @param {Object} [customMethods={}] — Méthodes additionnelles à ajouter au service
 * @returns {Object} Un objet avec les méthodes CRUD + les méthodes custom
 */
export function createService (endpoint, customMethods = {}) {
  return {
    // ── CRUD standard (signatures rétrocompatibles) ──
    list () {
      return api.get(endpoint)
    },

    save (data) {
      return api.post(endpoint, data)
    },

    view (id) {
      return api.get(`${endpoint}/${id}`)
    },

    update (data, id) {
      return api.put(`${endpoint}/${id}`, data)
    },

    remove (id) {
      return api.delete(`${endpoint}/${id}`)
    },

    // ── Méthodes custom ──
    ...customMethods,
  }
}
